export default {
  // 获取用户时区+8  +8.5 +10.75 -5
  timeZone () {
    let timezone = new Date().getTimezoneOffset() / 60
    // let mins = (new Date().getTimezoneOffset() / 60 - parseInt(timezone)) * 60
    let zone = -timezone > 0 ? '+' + String(-timezone) : -timezone
    return zone
  },
  globetime () {
    let timezone = new Date().getTimezoneOffset() / 60
    let mins = (new Date().getTimezoneOffset() / 60 - parseInt(timezone)) * 60
    let zone = -timezone > 0 ? '+' + -parseInt(timezone) + ':' + (-mins > 0 ? -mins : '00') : -parseInt(timezone) + ':' + (-mins > 0 ? -mins : '00')
    return zone
  },
  getTimeZoneCity () {
    let timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone; //'Asia/Shanghai'
    return timeZoneId
  },
  formatDate (time) {
    var date = new Date(time.replace(/-/g, '/'))
    return date
  },
  /**
   * 金额千位分隔
   * @param {num} num 2999
   * @returns 2,999.00
   */
  numFormat (num) {
    let price = Number(num)
      .toFixed(2)
      .toString()
      .replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')
      // var c = (num.toString().indexOf ('.') !== -1) ? num.toLocaleString() : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    return price
  },
  /**
   * 日期转换格式
   * @param {date} date 2021-06-02 21:28:47
   * @returns 2021/6/2
   */
  setDate (date) {
    var date = new Date(date)
    return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()
  },
  /**
   * 日期转换星期
   * @param {date} date 2021-06-02 21:28:47
   * @returns Sunday
   */
  setDateToWeek (date) {
    var date = new Date(date), week
    if (date.getDay() == 0) week = 'Sunday'
    if (date.getDay() == 1) week = 'Monday'
    if (date.getDay() == 2) week = 'Tuesday'
    if (date.getDay() == 3) week = 'Wednesday'
    if (date.getDay() == 4) week = 'Friday'
    if (date.getDay() == 5) week = 'Friday'
    if (date.getDay() == 6) week = 'Saturday'
    return week
  },
  /**
 * 数字转换英文
 * @param {date} date 2021-06-02 21:28:47
 * @returns Sunday
 */
  setWeek (num) {
    switch (num) {
      case '7':
        return 'Sunday'
        break
      case '6':
        return 'Saturday'
        break
      case '5':
        return 'Friday'
        break
      case '4':
        return 'Thursday'
        break
      case '3':
        return 'Wednesday'
        break
      case '2':
        return 'Tuesday'
        break
      case '1':
        return 'Monday'
        break
      default:
        return ''
    }
  },
  toAppStore () {
    window.location.href = 'https://apps.apple.com/cn/app/id1573232431'
  },
  toGooglePlay () {
    window.location.href = 'http://www.pgyer.com/jtIz'
  },
  setCookies (obj, limitTime) {
    // let data = new Date(new Date().getTime() + limitTime * 24 * 60 * 60 * 1000).toUTCString()

    for (let i in obj) {
      document.cookie = i + '=' + obj[i]
    }
  },
  getCookie (name) {
    // let re = new RegExp('s?' + cookieName + '=([^;]+)(;|$)')
    var arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'))
    if (arr != null) {
      return unescape(arr[2])
    } else {
      return null
    }
  },
  clearCookie (name) {
    let json = {}
    json[name] = ''
    this.setCookies(json, -1)
  },
  // GetQueryString (name) {
  //   // var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  //   if (window.location.href.indexOf(name) > 0) { var r = window.location.href.split(name)[1].split('=')[1] }
  //   if (r != null) return r; return null
  // }
  /**
   * 从当前URL中获取指定查询参数的值
   * @param {string} name - 要获取的参数名称
   * @returns {string|null} - 返回参数值，如果不存在则返回null
   */
  GetQueryString(name) {
    // 方法1：使用现代浏览器支持的URLSearchParams API（推荐）
    try {
      // 创建URL查询参数对象
      const urlParams = new URLSearchParams(window.location.search);

      // 检查参数是否存在
      if (urlParams.has(name)) {
        // 返回解码后的参数值（自动处理URL编码和+号空格）
        return decodeURIComponent(urlParams.get(name));
      }
    } catch (e) {
      // 如果URLSearchParams不可用，则回退到正则表达式方法
      console.warn("URLSearchParams not supported, falling back to regex");
    }

    // // 方法2：正则表达式兼容方案（支持旧浏览器）
    // // 构建匹配模式：参数名前可以是?或&，后跟=，然后捕获值直到遇到&、#或结尾
    // const regex = new RegExp(`[?&]${name}=([^&#]*)`);
    // const result = window.location.href.match(regex);
    //
    // // 如果匹配成功则返回解码后的值，否则返回null
    // return result ? decodeURIComponent(result[1].replace(/\+/g, ' ')) : null;
  },
  getCustomColor(index){
    if(index==1)return'#999999'
    if(index==2)return'#FF6E17'
    if(index==3)return'#10B981'
  },
  getBgColor(index){
    if(index==1)return'#EEEEEE'
    if(index==2)return'#FFE2D1'
    if(index==3)return'#CFF1E6'
  },
  getStatusText(index){
    if(index==1)return'未学习'
    if(index==2)return'进行中'
    if(index==3)return'已学完'
  },
  getHomeworkColor(index){
    if(index==1)return['#FF4000','rgba(255, 0, 0, 0.1)','未提交']
    if(index==2)return['#3B82F6','rgba(59, 130, 246, 0.2)','已提交']
    if(index==4)return['#10B981','rgba(16, 185, 129, 0.2)','已批阅']
    if(index==5)return['#FF6E17','rgba(255, 110, 23, 0.2)','草稿']
    if(index==7)return['#999999','rgba(156, 163, 175, 0.2)','已结束']
  },
  getScore(n){
    if(n==1)return'不及格'
    if(n==2)return'一般'
    if(n==3)return'中等'
    if(n==4)return'良好'
    if(n==5)return'优秀'
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js